import { FC } from 'react';

import { useEmployerVerificationState } from 'src/components/EmployerVerification/useEmployerVerificationState';

import BuyContacts from 'src/components/Search/Resume/Header/Banners/BuyContacts';
import RegistrationAction from 'src/components/Search/Resume/Header/Banners/RegistrationAction';

const ResumeSearchHeaderBanners: FC = () => {
    const { isUnverifiedHhRuEmployer } = useEmployerVerificationState();
    return (
        <>
            <BuyContacts />
            {!isUnverifiedHhRuEmployer && <RegistrationAction />}
        </>
    );
};

export default ResumeSearchHeaderBanners;
